import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import StocktransferHeader from "./stock-transfer-header";
import AddButton, { DraftButton } from "../../buttons/button";
import StocktransferItemTable from "./stock-transfer-item-table";
import {
  binLocationListAction,
  wareHouseListAction,
} from "../../../redux/actions/general-action";
import BatchQuantityBinPopover from "./batch-qty-bin-popover1";
import moment from "moment";
import {
  stockTransferCreateAction,
  stockTransferEditAction,
} from "../../../redux/actions/inventory-action";
import errorToast from "../../helper-components/error-toast";
import successToast from "../../helper-components/success-toast";
import StocktransferHeadSec from "./stock-transfer-head-sec";
import StocktransferItemSec from "./stock-transfer-items-sec";
import StockTransferBatchesPanel from "./stock-transfer-batches-panel";
import { handleShowErrorToast } from "../../helper-components/helper-function";

const CreateEditViewStockTransfers = ({
  disabled = false,
  stockTransferDetails = {},
  page = "",
}) => {
  const [heading, setHeading] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const stockTransferData = stockTransferDetails?.stocktransferData ?? {};
  const today = new Date();
  const itemData = stockTransferDetails?.itemData ?? [];
  const [warehouse, setWarehouse] = useState("");
  const [warehousename, setWarehousename] = useState("");
  const searchRef = useRef(null);
  const isDispatchingRef = useRef(false);
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [warehouseList, setWarehouseList] = useState([]);
  const [binLocationList, setBinLocationList] = useState([]);
  const date = new Date();
  useEffect(() => {
    dispatch(wareHouseListAction(onSuccessWare, onerrorWare));
    dispatch(binLocationListAction(onSuccessBin, onerrorBin));
    const value = localStorage.getItem("warehouse_id");
    const name = localStorage.getItem("warehouse_name");
    if (value) {
      setWarehouse(value);
    }
    if (name) {
      setWarehousename(name);
    }
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const stockTransferData = parsed.find(
        (obj) => obj?.stock_transfer_create
      );
      if (stockTransferData?.stock_transfer_create) {
        const cols = [...stockTransferData.stock_transfer_create];
        if (!cols.some((c) => c.value === "total_sellable_quantity")) {
          const uomIdx = cols.findIndex((c) => c.value === "item_uom");
          const insertAt = uomIdx !== -1 ? uomIdx + 1 : cols.length;
          cols.splice(insertAt, 0, {
            label: "Avail Qty",
            value: "total_sellable_quantity",
            minWidth: 100,
            alignment: "right",
          });
        }
        setHeading(cols);
      }
    }
  }, []);
  const onSuccessWare = (data) => {
    setWarehouseList(
      data?.data?.map((item) => ({
        label: `${item?.store_code ?? "-"}${item?.warehouse_name ? ` - ${item.warehouse_name}` : ""}`,
        value: item?.warehouse_id,
      }))
    );
  };
  const onerrorWare = () => { };
  const onSuccessBin = (data) => {
    setBinLocationList(
      data?.data?.map((item) => ({
        label: (
          <span
            className={`${item?.is_expired_bin_location ||
              item?.is_non_sellable_bin_location
              ? "text-F51D00"
              : ""
              }`}
          >
            {item?.bin_location_no}
            {item?.is_expired_bin_location}
            {item?.is_non_sellable_bin_location}
          </span>
        ),
        value: item?.bin_no_id,
        actualLabel: item?.bin_location_no,
      }))
    );
  };
  const onerrorBin = () => { };

  const initialData = {
    sl_no: 1,
    item_name: "",
    item_code: "",
    item_batches: [],
    item_quantity: 0,
    item_uom: "",
    current_avail: {
      item_uom_source: "",
      item_uom_destination: "",
    },
    from_warehouse_id: "",
    from_warehouse_name: "",
    to_warehouse_id: "",
    to_warehouse_name: "",
    item_id: "",
    item_uom_id: "",
    base_quantity: 0,
  };
  const initialFormValues = {
    ...(page === "edit" ? { itt_id: stockTransferData?.itt_id } : {}),
    stock_management_action: stockTransferData?.stock_management_action ?? "",
    from_warehouse_id: stockTransferData?.from_warehouse_id ?? "",
    to_warehouse_id: stockTransferData?.to_warehouse_id ?? "",
    posting_date: stockTransferData?.posting_date
      ? moment(stockTransferData?.posting_date).format("YYYY-MM-DD")
      : moment(today).format("YYYY-MM-DD"),
    stock_transfer_reason: stockTransferData?.stock_transfer_reason ?? "",
    data: [
      ...itemData?.map((item) => ({
        sl_no: 1,
        item_name: item?.item_name,
        item_code: item?.item_code,
        item_uom: item?.item_uom,
        quantity: item?.item_quantity ?? "",
        item_batches:
          item?.itemBatchData?.map((bch) => ({
            item_id: bch?.item_id,
            item_batch_number: bch?.item_batch_number,
            item_batch_quantity: bch?.item_batch_quantity,
            from_bin_location: bch?.from_bin_location,
            item_batch_free_quantity: bch?.item_batch_free_quantity,
            item_batch_purchase_rate: bch?.item_batch_purchase_rate,
            item_batch_unit_price: bch?.item_batch_unit_price,
            to_bin_location: bch?.to_bin_location,
            item_exp_date: moment(bch?.item_exp_date).format("YYYY-MM-DD"),
            from_bin_id: bch?.from_bin_id,
            to_bin_id: bch?.to_bin_id,
          })) ?? [],
        current_avail: {
          item_uom_source: "",
          item_uom_destination: "",
        },
        from_warehouse_id: item?.from_warehouse_id,
        from_warehouse_name: item?.from_warehouse_name,
        to_warehouse_id: item?.to_warehouse_id,
        to_warehouse_name: item?.to_warehouse_name,
        item_id: item?.item_id,
        item_uom_id: item?.item_uom_id,
        base_quantity: item?.base_quantity,
      })),
      initialData,
    ],
  };
  const [initialValue] = useState(initialFormValues);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    stock_management_action: Yup.string().required("Stock Action is required"),
    from_warehouse_id: Yup.string().when("stock_management_action", {
      is: (val) => val === "stock_out" || val === "in_store_transfer",
      then: (schema) => schema.required("Source from is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    to_warehouse_id: Yup.string().when("stock_management_action", {
      is: (val) =>
        val === "stock_in" ||
        val === "in_store_transfer" ||
        val === "stock_transfer_request",
      then: (schema) => schema.required("Destination to is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    stock_transfer_reason: Yup.string().required("Reason is required"),
    data: Yup.array().of(
      Yup.object().shape({
        item_id: Yup.string(),
        item_uom: Yup.string().when("item_id", {
          is: (val) => val && val.length > 0,
          then: (schema) => schema.required("UOM is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
        quantity: Yup.number().when("item_id", {
          is: (val) => val && val.length > 0,
          then: (schema) =>
            schema
              .required("Quantity is required")
              .moreThan(0, "Quantity must be greater than 0"),
          otherwise: (schema) => schema.notRequired(),
        }),
        item_batches: Yup.array().of(
          Yup.object().shape({
            item_batch_purchase_rate: Yup.number()
              .typeError("Must be a number")
              // .required("Purchase rate is required")
              .moreThan(0, "Purchase rate must be greater than 0"),
            item_batch_unit_price: Yup.number()
              .typeError("Must be a number")
              // .required("Unit price is required")
              .moreThan(0, "Unit price must be greater than 0"),

            item_batch_quantity: Yup.number()
              .integer("Quantity must be an integer")
              .required("Sellable quantity is required")
              // .typeError("Must be a number")
              .moreThan(0, "Qty must be greater than 0"),
            item_batch_free_quantity: Yup.number()
              .transform((value) =>
                typeof value === "string" ? parseInt(value, 10) : value
              ) // Transform string to number
              // .typeError("Must be a number")
              .integer("Quantity must be an integer"),
            item_batch_number: Yup.string(),
            // .required(
            //   "Batch number is required"
            // ),
            // to_bin_id: Yup.string().required("Bin ID is required"),
            item_exp_date: Yup.date(),
            // .required("Expiration date is required"),
          })
        ),
      })
    ),
  });
  function dispatchFn(values) {
    if (isDispatchingRef.current) return;
    let actionType = stockTransferCreateAction;
    if (page === "edit") {
      actionType = stockTransferEditAction;
    }
    isDispatchingRef.current = true;
    setLoadingButton(true);
    dispatch(
      actionType(
        {
          stockTransferData: {
            ...(page === "edit" ? { itt_id: values?.itt_id } : {}),
            warehouse_id: warehouse,
            warehouse_name: warehousename,
            stock_management_action: values?.stock_management_action,
            posting_date: values?.posting_date,
            from_warehouse_id: values?.from_warehouse_id,
            from_warehouse_name: warehouseList?.find(
              (item) => item?.value === values?.from_warehouse_id
            )?.label,
            to_warehouse_id: values?.to_warehouse_id,
            to_warehouse_name: warehouseList?.find(
              (item) => item?.value === values?.to_warehouse_id
            )?.label,
            stock_transfer_reason: values?.stock_transfer_reason,
          },
          itemData: values?.data?.slice(0, -1)?.map((item) => ({
            item_id: item?.item_id,
            item_name: item?.item_name,
            item_uom: item?.item_uom,
            item_code: item?.item_code,
            item_quantity: item?.quantity,
            item_uom_id: item?.item_uom_id ?? "",
          })),
          itemBatchData:
            values?.stock_management_action === "stock_transfer_request"
              ? [{}]
              : values.data
                ?.slice(0, -1)
                .map((item) =>
                  item.item_batches.map((batch) => {
                    const { created_date, remainingQty, ...rest } = batch;
                    return {
                      ...rest,
                      item_uom_id: item?.item_uom_id ?? "",
                      item_uom: item?.item_uom ?? "",
                    };
                  })
                )
                .flat(),
        },
        onSuccess,
        onError
      )
    );
  }

  const handleSubmit = (values) => {
    const isValidQuantity = values?.data?.slice(0, -1)?.every((item) => {
      const totalBatchQuantity = item.item_batches.reduce(
        (acc, batch) => acc + (parseFloat(batch.item_batch_quantity) || 0),
        0
      );
      return totalBatchQuantity === parseFloat(item.quantity);
    });
    const missingBatchNumbers = values?.data
      ?.slice(0, -1)
      .some((item) =>
        item.item_batches.some((batch) => !batch.item_batch_number)
      );
    const missingExpDate = values?.data
      ?.slice(0, -1)
      .some((item) => item.item_batches.some((batch) => !batch.item_exp_date));

    const missingQty = values?.data
      ?.slice(0, -1)
      .some((item) =>
        item.item_batches.some(
          (batch) =>
            !batch.item_batch_quantity ||
            parseFloat(batch.item_batch_quantity) === 0 ||
            batch.item_batch_quantity === ""
        )
      );
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);

    if (values?.data?.slice(0, -1)?.length < 1) {
      errorToast("Please add items");
    } else if (
      values?.data
        ?.slice(0, -1)
        .some((item) => parseInt(item.quantity) === 0 || item.quantity === "")
    ) {
      errorToast("Quantity cannot be zero");
    } else if (
      !isValidQuantity &&
      values?.stock_management_action !== "stock_transfer_request"
    ) {
      errorToast("Quantities do not match");
    } else if (missingBatchNumbers || missingQty || missingExpDate) {
      errorToast("Please add batch number, Exp date and Qty for all batches");
    } else if (missingUOM) {
      errorToast("Please add UOM for all items");
    } else if (values?.stock_management_action === "stock_transfer_request") {
      dispatchFn(values);
    } else {
      dispatchFn(values);
    }
  };
  const onSuccess = (data) => {
    isDispatchingRef.current = false;
    setLoadingButton(false);
    successToast(data?.message);
    navigate("/stock-transfer");
  };
  const onError = (data) => {
    isDispatchingRef.current = false;
    setLoadingButton(false);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, errors }) => {
          console.log(values, "dfsfdsffdsdfsdfsfsfs");
          return (
            <Form className="h-full">
              <div
                style={{
                  height: `calc(100% - 4rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <StockTransferBatchesPanel
                  open={addbatch}
                  disabled={disabled}
                  disName="gort_total_discount"
                  binLocationList={binLocationList}
                  setItemId={setItemId}
                  itemId={itemId}
                  setOpen={setAddbatch}
                  itemValues={values}
                />
                <StocktransferHeadSec
                  warehouseList={warehouseList}
                  warehouse={warehouse}
                  binLocationList={binLocationList}
                  disabled={disabled}
                  initialData={initialData}
                />
                <StocktransferItemSec
                  heading={heading}
                  initialData={initialData}
                  disabled={disabled}
                  searchRef={searchRef}
                  addBatchFn={(id) => {
                    setAddbatch(true);
                    setItemId(id);
                  }}
                />
              </div>
              {!disabled && (
                <div className="h-[4rem] flex justify-between px-5">
                  <div></div>
                  <div className="flex gap-3 items-center">
                    <AddButton
                      prefixIcon={false}
                      text={"Transfer"}
                      isDisabled={
                        loadingButton || values?.data?.slice(0, -1)?.length < 1
                      }
                      className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)] 
font-[var(--primary-button-font-weight)]
"
                      onclkFn={() => {
                        setFieldValue("submittedButton", "draft");
                        console.log(errors, "errorrssssssss");
                        if (Object.keys(errors).length > 0) {
                          handleShowErrorToast(errors);
                        }
                      }}
                      type="submit"
                    />
                  </div>
                </div>
              )}

              {/* <div className="flex flex-col h-full ">
                <div class="flex flex-wrap justify-between first-div px-3 pt-3">
                  <StocktransferHeader
                    initialData={initialData}
                    warehouse={warehouse}
                    warehouseList={warehouseList}
                    disabled={disabled}
                  />
                </div>
                {addbatch && (
                  <BatchQuantityBinPopover
                    setItemId={setItemId}
                    itemId={itemId}
                    setAddbatch={setAddbatch}
                    binLocationList={binLocationList}
                    disabled={disabled}
                    itemValues={values}
                  />
                )}
                <div
                  className="flex flex-col"
                  style={{
                    maxHeight: `calc(100% - ${heightOfFirstDiv}px)`,
                    height: `calc(100% - ${heightOfFirstDiv}px)`,
                  }}
                >
                  <div className="overflow-y-auto">
                    {values?.stock_management_action && (
                      <StocktransferItemTable
                        addBatchFn={(id) => {
                          setAddbatch(true);
                          setItemId(id);
                        }}
                        disabled={disabled}
                        searchRef={searchRef}
                        initialData={initialData}
                      />
                    )}
                  </div>
                </div>
              </div> */}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewStockTransfers;
